module.exports = {
    tag: 'lunatic',
    quality: Math.random(),
    learning: Math.round( -3 + Math.random()*6 ),
    perception: Math.round( -3 + Math.random()*6 ),
    mana: Math.round( -3 + Math.random()*6 )
};